import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import { sortByManagerAndMonthYear } from "../../util/sortCart";

// Палитра цветов для менеджеров (циклически)
const COLORS = [
  "#e91e63",
  "#8e24aa",
  "#3f51b5",
  "#03a9f4",
  "#009688",
  "#4caf50",
  "#ff9800",
  "#ff5722",
  "#795548",
  "#607d8b",
  "#c2185b",
  "#673ab7",
];

function ChartManager({ manager }) {
  const { rows, managers } =
    manager && manager.length !== 0
      ? sortByManagerAndMonthYear(manager)
      : { rows: [], managers: [] };

  return (
    <div className="">
      <div>
        <div className="w-[97%] h-[300px] m-auto mt-[20px]">
          <ResponsiveContainer>
            <AreaChart data={rows}>
              <defs>
                <linearGradient id="mgrIn" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#739D00" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#739D00" stopOpacity={0} />
                </linearGradient>
                {managers.map((m, idx) => {
                  const color = COLORS[idx % COLORS.length];
                  return (
                    <linearGradient
                      key={`grad-${m}`}
                      id={`mgr-${idx}`}
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor={color} stopOpacity={0.6} />
                      <stop offset="95%" stopColor={color} stopOpacity={0} />
                    </linearGradient>
                  );
                })}
              </defs>
              <XAxis dataKey="name" stroke="gray" />
              <CartesianGrid
                strokeDasharray="3 3"
                className="stroke-[#9c9a9a]"
              />
              <Tooltip />
              <Legend />
              <Area
                type="monotone"
                dataKey="IN"
                stroke="#739D00"
                fillOpacity={1}
                fill="url(#mgrIn)"
              />
              {managers.map((m, idx) => {
                const color = COLORS[idx % COLORS.length];
                return (
                  <Area
                    key={`area-${m}`}
                    type="monotone"
                    dataKey={m}
                    stroke={color}
                    fillOpacity={1}
                    fill={`url(#mgr-${idx})`}
                  />
                );
              })}
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default ChartManager;
